export default "__VITE_ASSET__CJVZnvVL__"